import { SESSION } from 'core/constants/endpoints'
import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'

export default function trackAnswers(
  hcStorage: Pivot.Store,
  answers: Pivot.GenericKeyPair<any>
): Promise<any> {
  const data = {
    Questions: answers,
    UserId: hcStorage.healthcareUserId,
    SessionId: hcStorage.healthcareSession
  }
  const url = `${SESSION}/applicantContext/answers`
  return Object.keys(answers).length
    ? fetchJSONHandleError({ url, data })
    : Promise.resolve()
}
